module.exports = __webpack_public_path__ + "static/media/trees_48.4016b68f.png";